module.exports = __webpack_public_path__ + "img/icon-folder-localization.c9520ad8.svg";